/**
 * 辅料模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取辅料列表
export const ingredientsList = (params) => {
  return req.get('/hosp/ingredients/list', params);
}

// 新增辅料
export const ingredientsAdd = (params) => {
  return req.post('/hosp/ingredients', params);
}

// 修改辅料信息
export const ingredientsEdit = (params) => {
  return req.put('/hosp/ingredients', params);
}

// 删除辅料信息
export const ingredientsDelete = (ingredientsIds) => {
  return req.delete(`/hosp/ingredients/${ingredientsIds}`);
}
// 获取辅料模版列表
export const ingredientTemplateList = (params) => {
  return req.get('/ingredients/template/list', params);
}
// 新增辅料模版
export const ingredientsAddTemplate = (params) => {
  return req.post('/ingredients/template', params);
}
// 删除辅料模版信息
export const ingredientsTemplateDelete = (id) => {
  return req.delete(`/ingredients/template/${id}`);
}
// 修改辅料模版信息
export const ingredientTemplateEdit = (params) => {
  return req.put('/ingredients/template', params);
}
